import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { LeadPriorityScore } from "app/pages/sales-intelligence/domain/leads/types/lead-priority";

type PendingScoringRule = {
    readonly priority: LeadPriorityScore;
    readonly onCreated: (priority: LeadPriorityScore) => void;
};

interface IScoringRuleWizardState {
    readonly pending: PendingScoringRule | undefined;
    /** Open the scoring-rule flow for a priority. `onCreated` fires once a rule is saved. */
    readonly open: (priority: LeadPriorityScore, onCreated: (priority: LeadPriorityScore) => void) => void;
    /** Close the flow. No-op when already closed. */
    readonly close: () => void;
}

/**
 * Transport for the host that owns the modals.
 * The wizard subtree is mounted only while `pending` is set,
 * so its scoring-config queries never compete with the filters fetch.
 */
export const useScoringRuleWizardStore = create<IScoringRuleWizardState>()(
    devtools(
        (set) => ({
            pending: undefined,
            open: (priority, onCreated) => set({ pending: { priority, onCreated } }, false, "open"),
            close: () => set({ pending: undefined }, false, "close"),
        }),
        { name: "ScoringRuleWizardStore" },
    ),
);
